import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import ProcessSection from '../components/sections/ProcessSection';
import FAQSection from '../components/sections/FAQSection';
import CTASection from '../components/sections/CTASection';

const HomePage = () => {
  const organizationStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "PySolutions",
    "legalName": "PySolutions",
    "url": "https://pysolutions.dev",
    "logo": "https://pysolutions.dev/PySolutions.jpeg",
    "description": "Full-stack AI product studio. We ship production AI products on Next.js, FastAPI, Django, Celery, Redis, Postgres + pgvector, and LangChain/LangGraph.",
    "foundingDate": "2019",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "RS"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "sales",
        "email": "info@pysolutions.dev",
        "availableLanguage": ["English"]
      }
    ],
    "sameAs": [
      "https://www.linkedin.com/company/pysolutions-dev",
      "https://github.com/PySolutions-dev"
    ],
    "knowsAbout": [
      "Next.js",
      "Django",
      "FastAPI",
      "Celery",
      "Redis",
      "pgvector",
      "LangChain",
      "LangGraph",
      "PostgreSQL",
      "Python",
      "AI Agents",
      "Retrieval-Augmented Generation",
      "LLM fine-tuning",
      "LLM evaluation",
      "Claude Code",
      "Model Context Protocol",
      "Generative media pipelines",
      "vLLM"
    ]
  };

  return (
    <>
      <Helmet>
        <title>PySolutions — Full-stack AI Product Studio | Europe</title>
        <meta name="description" content="We ship production-grade AI products on Next.js, FastAPI/Django, Celery, Redis, Postgres+pgvector, and LangChain. Senior-led, Europe-based engineering. info@pysolutions.dev." />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="PySolutions" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="PySolutions — Full-stack AI Product Studio | Europe" />
        <meta property="og:description" content="We ship production-grade AI products on Next.js, FastAPI/Django, Celery, Redis, Postgres+pgvector, and LangChain. Senior-led, Europe-based engineering." />
        <meta property="og:url" content="https://pysolutions.dev/" />
        <meta property="og:image" content="https://pysolutions.dev/og-card.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="PySolutions | Full-stack AI Product Studio" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PySolutions — Full-stack AI Product Studio | Europe" />
        <meta name="twitter:description" content="Production-grade AI products on Next.js + FastAPI/Django + Celery + Redis + pgvector + LangChain. Senior-led, Europe-based." />
        <meta name="twitter:image" content="https://pysolutions.dev/og-card.jpg" />
        <meta name="twitter:image:alt" content="PySolutions | Full-stack AI Product Studio" />

        {/* Canonical URL - Single canonical link only */}
        <link rel="canonical" href="https://pysolutions.dev/" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(organizationStructuredData)}
        </script>
      </Helmet>

      <div className="home-page page-hero">
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <FAQSection />
        <CTASection />
      </div>
    </>
  );
};

export default HomePage;
